import React, { useState } from "react";
import { ChevronDown, ShieldAlert, ScrollText } from "lucide-react";
import { TERMS } from "../mock";

export default function Terms() {
  const [open, setOpen] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? TERMS : TERMS.slice(0, 4);
  return (
    <section id="terms" className="py-24 bg-[#070d19] border-y border-[rgba(46,155,255,0.1)]">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <span className="text-[12px] tracking-[0.25em] text-[#2e9bff] font-semibold">LEGAL</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mt-4 flex items-center justify-center gap-3">
            <ScrollText className="w-9 h-9 text-[#2e9bff]" /> Terms & <span className="text-blue-grad">Conditions</span>
          </h2>
          <p className="text-slate-400 mt-4">Please read these terms carefully before using THE REAL ALGO products and services.</p>
        </div>

        <div className="mt-10 space-y-3">
          {visible.map((t, i) => (
            <div key={i} className="glass-card rounded-xl overflow-hidden">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between px-5 py-4 text-left">
                <span className="text-white font-medium">{t.t}</span>
                <ChevronDown className={`w-5 h-5 text-[#2e9bff] transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p className="px-5 pb-5 text-slate-400 text-sm leading-relaxed">{t.d}</p>}
            </div>
          ))}
        </div>

        {!showAll && (
          <div className="text-center mt-6">
            <button onClick={() => setShowAll(true)} className="btn-ghost px-6 py-2.5 rounded-full text-sm font-semibold">View All 10 Terms</button>
          </div>
        )}

        <div className="mt-8 flex items-start gap-3 p-5 rounded-xl bg-[rgba(255,90,90,0.06)] border border-[rgba(255,90,90,0.25)]">
          <ShieldAlert className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
          <p className="text-slate-300 text-sm"><span className="text-white font-semibold">Risk Disclaimer:</span> Trading forex and gold involves significant risk. All profits and losses in this market are subject to market risk. Past performance is not indicative of future results. Never trade with capital you cannot afford to lose. <span className="text-white font-semibold">Strictly no-refund policy — all sales are final.</span> THE REAL ALGO is not a licensed financial advisor.</p>
        </div>
        <p className="text-center text-slate-500 text-xs mt-6">Last Updated: March 2026</p>
      </div>
    </section>
  );
}
